import {createAction} from '@reduxjs/toolkit';
import {MAP_DRAW_LAYERS, MAP_TOOLS} from '@src/constants';
import {type Feature} from 'geojson';
import {type Coordinate} from 'ol/coordinate';
import {type Extent} from 'ol/extent';

export type DrawTool = {
  name: keyof typeof MAP_TOOLS;
  layer: keyof typeof MAP_DRAW_LAYERS;
  target: string;
};

export const pinMap = createAction<Coordinate | null>('PIN_MAP');

export const clearMapPin = createAction('CLEAR_PIN_MAP');

export const setMapExtent = createAction<Extent | null>('SET_MAP_EXTENT');

export const setBufferedMapExtent = createAction<Extent | null>(
  'SET_BUFFERED_MAP_EXTENT',
);

export const fitExtent = createAction<Extent | null>('FIT_MAP_EXTENT');

export const setDrawTool = createAction<DrawTool | null>('SET_DRAW_TOOL');

export const setCenterMarkerCoord = createAction<Coordinate | null>(
  'map/setCenterMarkerCoord',
);

export const setFeature = createAction<Feature | null | undefined>(
  'map/feature',
);

export const setIsOverZoomed = createAction<boolean>('map/isOverzoomed');
